import React from 'react';
import { Link } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as Checked } from '../../../../../../assets/img/Checked.svg';
import SubHeader from '../../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import { appConfig } from '../../../../../../config/app';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    checked: {
      '& path': {
        stroke: '#0033A0',
      },
    },
  })
);

const FastManagement = () => {
  const classes = useStyle();

  return (
    <>
      {/* <Box display={loading ? 'block' : 'none'}>
                <Loader action={'Cargando denuncias'}></Loader>
            </Box> */}

      <SubHeader
        content={
          <Box>
            <Typography variant="h6">Talleres de Gestión rápida</Typography>
          </Box>
        }
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={4}>
            <Typography variant="h6">
              Para evaluar los daños de tu vehículo debemos inspeccionarlo
            </Typography>
          </Box>
          <Box my={2}>
            <Typography>
              Para ello podés acercarte a uno de los talleres de la lista de
              Gestión rápida disponible en el siguiente enlace:
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid
          item
          xs={11}
          style={{
            display: 'flex',
            marginTop: '1rem',
            marginBottom: '1rem',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            href={
              appConfig.SHORT_NAME === 'ANSWER'
                ? 'https://answerseguros.com.ar/talleres-cercanos'
                : 'https://www.galiciaseguros.com.ar/portal/talleres-gestion-rapida'
            }
            target="_blank"
          >
            Abrir enlace
          </Button>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={2} mb={3} style={{ display: 'flex' }}>
            <Box>
              <Checked></Checked>
            </Box>
            <Box style={{ marginLeft: '5px' }}>
              <Typography>
                Sin necesidad de solicitar un turno previo, día y horario.
                Disponiendo de tu unidad si cuenta con movilidad propia en todo
                momento hasta la fecha de reparación.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default FastManagement;
